import {
  GET_ENTITY_REPORT_OPTIONS,
  GET_ENTITY_REPORT_OPTIONS_ERROR,
  GET_ENTITY_REPORT_OPTIONS_SUCCESS,
  GET_ENTITY_REPORT_BUYER_OPTIONS,
  GET_ENTITY_REPORT_BUYER_OPTIONS_ERROR,
  GET_ENTITY_REPORT_BUYER_OPTIONS_SUCCESS
} from './DownloadOrdersAndBiddingsSection.actions'

const downloadOrdersAndBiddingsSectionState = {
  biddingOptions: [],
  error: null,
  loading: false,
  orderOptions: [],
  buyerOptions: []
}

/**
 * The download orders and biddings section's reducer.
 */
const downloadOrdersAndBiddingsSectionReducer = (state = downloadOrdersAndBiddingsSectionState, { payload, type }) => {
  switch (type) {
    case GET_ENTITY_REPORT_OPTIONS: {
      return downloadOrdersAndBiddingsSectionState
    }
    case GET_ENTITY_REPORT_OPTIONS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_ENTITY_REPORT_OPTIONS_SUCCESS: {
      return {
        ...state,
        biddingOptions: payload.biddingOptions,
        loading: false,
        orderOptions: payload.orderOptions
      }
    }
    case GET_ENTITY_REPORT_BUYER_OPTIONS: {
      return downloadOrdersAndBiddingsSectionState
    }
    case GET_ENTITY_REPORT_BUYER_OPTIONS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_ENTITY_REPORT_BUYER_OPTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        buyerOptions: payload.buyerOptions
      }
    }
    default: {
      return state
    }
  }
}

export default downloadOrdersAndBiddingsSectionReducer
